import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import personalDataPdf from "../../assets/personal_data_processing.pdf";
import Footer from "../../components/Footer/Footer";
import layoutStyles from "../../components/PolicyLayout/PolicyLayout.module.scss";
import Seo from "../../components/Seo/Seo";
import SiteNav from "../../components/SiteNav/SiteNav";
import { useLocale } from "../../contexts/LocaleContext";
import styles from "./PersonalDataPolicy.module.scss";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url).toString();

export default function PersonalDataPolicy() {
  const { messages } = useLocale();
  const copy = messages.personalDataPage;
  const viewerRef = useRef<HTMLDivElement>(null);
  const [pageWidth, setPageWidth] = useState<number>();
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    const viewer = viewerRef.current;
    if (!viewer) return;

    const observer = new ResizeObserver(([entry]) => setPageWidth(entry.contentRect.width));
    observer.observe(viewer);

    return () => observer.disconnect();
  }, []);

  return (
    <main className={layoutStyles.page}>
      <Seo title={copy.pageTitle} description={copy.description} path="/personal-data-policy" />

      <SiteNav solidThreshold={320} />

      <section className={layoutStyles.hero}>
        <div className={layoutStyles.container}>
          <div className={classNames(layoutStyles.heroInner, layoutStyles.heroInnerWide)}>
            <div className={classNames(layoutStyles.heroCopy, layoutStyles.heroCopyWide)}>
              <span className={layoutStyles.badge}>{copy.badge}</span>
              <h1>{copy.title}</h1>
              <p>{copy.description}</p>
            </div>
          </div>
        </div>
      </section>

      <div className={layoutStyles.surface}>
        <div className={layoutStyles.container}>
          <section className={styles.viewerSection}>
            <div ref={viewerRef} className={styles.viewer} aria-label={copy.viewerTitle}>
              <Document file={personalDataPdf} loading={null} onLoadSuccess={({ numPages }) => setPageCount(numPages)}>
                {pageWidth
                  ? Array.from({ length: pageCount }, (_, index) => (
                      <Page key={index} pageNumber={index + 1} width={pageWidth} className={styles.page} loading={null} />
                    ))
                  : null}
              </Document>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </main>
  );
}
